import { Participant, User } from '@core/data/models'
import { DEFAULT_AVATAR } from '@shared/utils/default-avatar'

export function userAdapter(participant: Participant): User {
  return {
    uid: participant.uid,
    name: participant.name,
    email: participant.email,
    avatar: participant.large_picture_url || participant.picture_url || participant.avatar || DEFAULT_AVATAR,
    authenticated: participant.authenticated,
    numero_de_documento: participant.numero_de_documento || '',
    celular: participant.celular || '',
    update_file: participant.update_file ?? false,
    tags: participant.tags ?? [],
    phoneNumber: participant.phone_number || '',
    personalEmail: participant.personal_email || '',
    address: participant.address || '',
    city: participant.city || '',
    nationalId: participant.national_id || '',
    birthDate: participant.birth_date || '',
    startDate: participant.start_date || '',
    numberOfChildren: participant.number_of_children || '',
    team: participant.team || '',
    sector: participant.sector || ''
  }
}
